var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
var CloseButton = /** @class */ (function (_super) {
    __extends(CloseButton, _super);
    function CloseButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CloseButton.prototype.render = function () {
        return (React.createElement("div", { className: "rj-popup-message__close-btn", onClick: this.props.onClick, "data-uat": "popup-message-close-btn" },
            React.createElement("span", { className: "rj-popup-message__close-btn--icon" })));
    };
    return CloseButton;
}(React.PureComponent));
export { CloseButton };
//# sourceMappingURL=CloseButton.js.map